import { ReactNode } from "react";

import { Box } from "@mui/material";
import {
    Column,
    ConditionalLink,
    OutlinedCardWithBanner,
    Row,
    Stat,
    StatProps,
    Text,
    useAppPalette
} from "@bridgesplit/ui";

export function FeaturedVaultCardBase({
    path,
    disabled,
    loading,
    banner,
    tokenImage,
    name,
    description,
    stats,
    cta
}: {
    path: string;
    disabled?: boolean;
    loading: boolean;
    banner: ReactNode;
    tokenImage: ReactNode;
    name?: string;
    description?: string;
    stats: StatProps[];
    cta: ReactNode;
}) {
    const { divider } = useAppPalette();

    return (
        <ConditionalLink
            disabled={disabled}
            to={path}
            sx={{ height: "100%", display: "flex", flexDirection: "column" }}
        >
            <Column sx={{ flexGrow: 1 }}>
                <OutlinedCardWithBanner
                    sx={{ flexGrow: 1, "&:hover": { backgroundColor: divider } }}
                    padding={2}
                    spacing={3}
                    banner={banner}
                >
                    <Column spacing={1}>
                        <Row spacing={1}>
                            {tokenImage}
                            <Text variant="h3" fontWeight="semibold" loading={loading}>
                                {name}
                            </Text>
                        </Row>
                        <Text variant="body2" color="caption" loading={loading}>
                            {description}
                        </Text>
                    </Column>

                    <Box
                        sx={{
                            display: "grid",
                            gridTemplateColumns: `repeat(${stats.length}, minmax(0, 1fr))`
                        }}
                    >
                        {stats.map((stat, index) => (
                            <Stat key={typeof stat.caption === "string" ? stat.caption : index} {...stat} />
                        ))}
                    </Box>
                    {cta}
                </OutlinedCardWithBanner>
            </Column>
        </ConditionalLink>
    );
}
